<template>
  <v-container class="hp-container">
    <v-layout wrap>
      <v-card raised class="my-4">
        <v-row pa-4>
          <v-col class="copy text-left py-6 px-12" xs="12" md="6" lg="5">
            <h2 class="pb-8 font-weight-light">SWINDON CRICKET CLUB</h2>
            <h1 class="pb-4 font-weight-regular">
              Located on the outskirts of Swindon, South Staffordshire.
            </h1>
            <p class="pb-4">
              Picturesque location on the bank of the canal, with a clubhouse
              and bar that are available for hire.
            </p>
            <v-card-actions>
              <v-btn to="/book" color="primary" rounded>Book Swindon Cricket Club</v-btn>
            </v-card-actions>
          </v-col>
          <v-col class="image-container py-0" md="6" lg="7">
            <v-img class="image" src="../assets/pitch.jpg" />
          </v-col>
        </v-row>
      </v-card>
      <v-row class="mobile-flex-column">
        <v-col xs="12" md="6">
          <v-card class="sub-card" raised>
            <v-img
              class="white--text align-end"
              src="../assets/findus.jpg"
              :aspect-ratio="16/9"
            >
              <h1 class="pb-4 px-8 font-weight-regular">
                Find Us
              </h1>
            </v-img>
            <p class="pt-4 px-8 font-weight-light text-uppercase">
              Hinksford Lane Playing Fields<br />
              Hinksford Lane<br />
              Swindon, Dudley, West Midlands<br />
              Staffordshire<br />
              DY3 4NU
            </p>
            <v-card-actions class="px-6">
              <v-btn color="accent" text target="_blank" href="https://goo.gl/maps/GQXmdryXLeRtztnTA">
                Directions
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'HelloWorld',

  data: () => ({})
};
</script>

<style scoped>


.v-card {
  border-radius: 8px !important;
}

@media only screen and (min-width: 600px) {
  .v-card {
    min-height: 430px!important;
  }
}

@media only screen and (min-width: 960px) {
  .v-card.sub-card {
      height: 525px;
    }
}

.image {
  border-top-right-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
  height: 100%;
}

@media only screen and (max-width: 960px) {
  .image-container {
   display: none;
  }
  .mobile-flex-column {
    display: flex;
    flex-direction: column;
  }
}

.copy {
  margin: auto;
}

p {
  opacity: 0.6;
}
</style>
